import Axios from "axios";
import config from "../app.config";

export var mailSentService
export default mailSentService = {
    getListMailSent,
    
}

// list function

async function getListMailSent(data) {
    let mailBox = data.mailBox
    let queries = data.queries
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailSent/${mailBox}`, {params: queries})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

